import { Flex } from "shared/components/Spor";
import { fadein } from "shared/components/transitions/fade";
import styled from "styled-components";

export const TodoHeader = styled.span`
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans";
`;

export const TodoMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: messages;
  overflow-y: auto;
  width: 100%;
  position: relative;
  padding: 0px 12px 0px 12px;
`;

export const TodoElementWrapper = styled.li`
  animation: ${fadein} 300ms ease-in;
  padding: 6px 1rem 1rem 1rem;
  background: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: 6px;
  width: 100%;
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 12px;
`;

export const TodoRowContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 12px;
  gap: 12px;
`;

const TodoSection = styled.div`
  width: 100%;
  border-radius: 6px;
  box-sizing: border-box;
`;

export const ListContainer = styled(TodoSection)`
  padding: 0;
  display: flex;
  overflow-y: scroll;
  scrollbar-color: ${({ theme }) => theme.colorSelected} rgba(0, 0, 0, 0);
  overflow-x: hidden;
  flex-direction: column;
  align-items: center;
  -webkit-scrollbar: none; /* WebKit */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ContainerFlex = styled(Flex)`
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-color: ${({ theme }) => theme.colorOutlineSecondary};
  border-width: 1px;
  border-radius: 6px;
`;

export const TopFlex = styled(Flex)`
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TodoNoMessage = styled.div`
  background: blue;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-color: ${({ theme }) => theme.colorOutlineSecondary};
  border-width: 1px;
  border-radius: 6px;
`;
